import { Fragment, useState } from "react";
import Grid2 from "@mui/material/Grid2";
import { deleteDealerInformation } from "./../../action/deviceDealer";
import { Box, Paper, Stack } from "@mui/material";
import Button from "../Common/Button/Button";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import {
  InfoPairLabel,
  InfoPairValue,
  SectionSubHeading,
} from "../Common/Typography/AppTypography";
import { useDesignTokens } from "../../theme/useDesignTokens";
import Dialog from "../Common/Dailog/Dailog";

const DisplayDeviceDealerDeatils = ({
  deviceDealerDetails,
  displayEditDeleteButton,
  onEditDeviceDealerDetails,
  onDeleteDeviceDealerDetails,
  setAlert,
}) => {
  const { colors } = useDesignTokens();
  const primaryColor = colors?.primary?.main;

  const [deleteDeviceDealer, setDeleteDeviceDealer] = useState(false);

  function handleDeleteDeviceDealerFromPopup() {
    deleteDealerInformation(deviceDealerDetails["id"])
      .then((res) => {
        setAlert("Dealer Deleted Sucessfully", "success");
        setDeleteDeviceDealer(false);

        onDeleteDeviceDealerDetails();
      })
      .catch((err) => {
        setAlert(
          err?.response?.data?.message ?? "Failed to Delete Dealer",
          "danger",
        );
        setDeleteDeviceDealer(false);
      });
  }

  return (
    <Fragment>
      <Paper
        elevation={3}
        sx={{
          p: { xs: 2, md: 3 },
          borderRadius: 2,
          mt: 1,
          boxShadow: 3,
        }}
      >
        {deviceDealerDetails && Object.keys(deviceDealerDetails).length > 0 && (
          <Fragment>
            {displayEditDeleteButton && (
              <Box display="flex" justifyContent="flex-end" mb={2}>
                <Stack direction="row" spacing={2}>
                  <Button
                    startIcon={<EditIcon />}
                    onClick={() =>
                      onEditDeviceDealerDetails(deviceDealerDetails)
                    }
                  >
                    Edit
                  </Button>

                  <Button
                    variant="danger"
                    startIcon={<DeleteIcon />}
                    onClick={() => setDeleteDeviceDealer(true)}
                  >
                    Delete
                  </Button>
                </Stack>
              </Box>
            )}

            <Grid2 container spacing={{ xs: 2, md: 3 }}>
              <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                <Box sx={{ mb: 1 }}>
                  <InfoPairLabel>Dealer ID</InfoPairLabel>
                  <InfoPairValue>{deviceDealerDetails["id"]}</InfoPairValue>
                </Box>
                <Box>
                  <InfoPairLabel>Name</InfoPairLabel>
                  <InfoPairValue>{deviceDealerDetails["name"]}</InfoPairValue>
                </Box>
              </Grid2>

              <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                <Box sx={{ mb: 1 }}>
                  <InfoPairLabel>Website</InfoPairLabel>
                  <InfoPairValue>
                    {deviceDealerDetails["website"]}
                  </InfoPairValue>
                </Box>
                <Box>
                  <InfoPairLabel>Email</InfoPairLabel>
                  <InfoPairValue>{deviceDealerDetails["email"]}</InfoPairValue>
                </Box>
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                <SectionSubHeading sx={{ color: primaryColor, mb: 1 }}>
                  Phone Details
                </SectionSubHeading>
                <Grid2 container columnSpacing={2} rowSpacing={0.75} sx={{ mb: 1 }}>
                  <Grid2 size={5}>
                    <InfoPairLabel>Number</InfoPairLabel>
                  </Grid2>
                  <Grid2 size={4}>
                    <InfoPairLabel>Type</InfoPairLabel>
                  </Grid2>
                </Grid2>
                {deviceDealerDetails["phone"]?.map((phone, index) => (
                  <Grid2 container key={index} columnSpacing={2} rowSpacing={0.75} sx={{ mb: 0.5 }}>
                    <Grid2 size={5}>
                      <InfoPairValue>{phone.number}</InfoPairValue>
                    </Grid2>
                    <Grid2 size={4}>
                      <InfoPairValue>{phone.type}</InfoPairValue>
                    </Grid2>
                  </Grid2>
                ))}
              </Grid2>

              <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                <SectionSubHeading sx={{ color: primaryColor, mb: 1 }}>
                  Location
                </SectionSubHeading>
                <InfoPairLabel>Country</InfoPairLabel>
                <InfoPairValue>{deviceDealerDetails["country"]}</InfoPairValue>
              </Grid2>

              <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                <SectionSubHeading sx={{ color: primaryColor }}>
                  Address
                </SectionSubHeading>
                <Box sx={{ mt: 2 }}>
                  <Box sx={{ mb: 1 }}>
                    <InfoPairLabel>Line 1</InfoPairLabel>
                    <InfoPairValue>
                      {deviceDealerDetails?.address?.line1}
                    </InfoPairValue>
                  </Box>
                  <Box sx={{ mb: 1 }}>
                    <InfoPairLabel>Line 2</InfoPairLabel>
                    <InfoPairValue>
                      {deviceDealerDetails?.address?.line2}
                    </InfoPairValue>
                  </Box>
                  <Box sx={{ mb: 1 }}>
                    <InfoPairLabel>City</InfoPairLabel>
                    <InfoPairValue>
                      {deviceDealerDetails?.address?.city}
                    </InfoPairValue>
                  </Box>
                  <Box>
                    <InfoPairLabel>Pincode</InfoPairLabel>
                    <InfoPairValue>
                      {deviceDealerDetails?.address?.pincode ||
                        deviceDealerDetails?.address?.pin}
                    </InfoPairValue>
                  </Box>
                </Box>
              </Grid2>

              <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                <SectionSubHeading sx={{ color: primaryColor }}>
                  Social Links
                </SectionSubHeading>
                <Box sx={{ mt: 2 }}>
                  <Box sx={{ mb: 1 }}>
                    <InfoPairLabel>Facebook</InfoPairLabel>
                    <InfoPairValue>
                      {deviceDealerDetails?.socials?.facebook}
                    </InfoPairValue>
                  </Box>
                  <Box sx={{ mb: 1 }}>
                    <InfoPairLabel>Instagram</InfoPairLabel>
                    <InfoPairValue>
                      {deviceDealerDetails?.socials?.instagram}
                    </InfoPairValue>
                  </Box>
                  <Box>
                    <InfoPairLabel>X</InfoPairLabel>
                    <InfoPairValue>
                      {deviceDealerDetails?.socials?.x}
                    </InfoPairValue>
                  </Box>
                </Box>
              </Grid2>

              {deleteDeviceDealer && (
                <Dialog
                  open={deleteDeviceDealer}
                  onClose={() => {
                    setDeleteDeviceDealer(false);
                  }}
                  title={"Delete Device Dealer"}
                  actions={[
                    {
                      label: "Cancel",
                      variant: "ghost",
                      onClick: () => {
                        setDeleteDeviceDealer(false);
                      },
                    },
                    {
                      label: "Delete",
                      tooltip: "Click to delete the dealer profile.",
                      variant: "danger",
                      onClick: handleDeleteDeviceDealerFromPopup,
                      slotProps: {
                        popper: {
                          sx: { zIndex: 2400 },
                        },
                      },
                    },
                  ]}
                  sx={{
                    zIndex: 2300,
                  }}
                >
                  <Box
                    sx={{
                      bgcolor: colors?.disabled?.bg,
                      p: 3,
                      borderRadius: 2,
                      textAlign: "left",
                    }}
                  >
                    <SectionSubHeading sx={{ mb: 2 }}>
                      Are you sure you want to delete this dealer profile?
                    </SectionSubHeading>

                    <Box sx={{ mb: 1 }}>
                      <InfoPairLabel>Dealer ID:</InfoPairLabel>
                      <InfoPairValue>{deviceDealerDetails?.id}</InfoPairValue>
                    </Box>
                    <Box>
                      <InfoPairLabel>Name:</InfoPairLabel>
                      <InfoPairValue>{deviceDealerDetails?.name}</InfoPairValue>
                    </Box>
                  </Box>
                </Dialog>
              )}
            </Grid2>
          </Fragment>
        )}
      </Paper>
    </Fragment>
  );
};

export default DisplayDeviceDealerDeatils;
